import { breakpoints } from "./utils";

$(".testimonials .slider").slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    accessibility: false,
});

// $(".photo-slider .items").on("init", function (event, slick, direction) {
//     let totalHeight = $(".photo-slider .slick-track").outerHeight();
//     $(".photo-slider .item").each(function () {
//         let imgHeight = $(this).find("img").outerHeight();
//         $(this).css("padding-top", (totalHeight - imgHeight) / 2);
//     });
// });
// $(".photo-slider .items").slick({
//     variableWidth: true,
//     arrows: true,
//     dots: false,
//     prevArrow: window.slideBtns.prev,
//     nextArrow: window.slideBtns.next,
//     accessibility: false,
//     responsive: [
//         {
//             breakpoint: breakpoints.md,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 variableWidth: false,
//             },
//         },
//     ],
// });

// $(".entry-slider").slick({
//     prevArrow: window.slideBtns.prev,
//     nextArrow: window.slideBtns.next,
//     slidesToShow: 1,
//     variableWidth: true,
//     mobileFirst: true,
//     infinite: false,
//     accessibility: false,
//     responsive: [
//         {
//             breakpoint: breakpoints.md,
//             settings: {
//                 slidesToShow: 4,
//             },
//         },
//     ],
// });

// $(".card-slider").on("init", function (slick) {
//     let $slider = $(".card-slider");
//     var trackHeight = $slider.find(".slick-track").outerHeight();
//     $slider.find(".slick-slide").css("height", trackHeight + "px"); // equalize content heights
// });
// $(".card-slider").slick({
//     prevArrow: window.slideBtns.prev,
//     nextArrow: window.slideBtns.next,
//     slidesToShow: 1,
//     variableWidth: true,
//     mobileFirst: true,
//     infinite: false,
//     accessibility: false,
//     responsive: [
//         {
//             breakpoint: breakpoints.lg,
//             settings: "unslick",
//         },
//     ],
// });

$(".wp-block-pulp-product-slider .items").on("init", function (slick) {
    let $slider = $(".wp-block-pulp-product-slider .items");
    var trackHeight = $slider.find(".slick-track").outerHeight();
    $slider.find(".slick-slide").css("height", trackHeight + "px"); // equalize content heights
});
$(".wp-block-pulp-product-slider .items").slick({
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    slidesToShow: 1,
    variableWidth: true,
    mobileFirst: true,
    infinite: false,
    accessibility: false,
    responsive: [
        {
            breakpoint: breakpoints.lg,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
    ],
});

/*
PDP
*/
$(".product-media .main").slick({
    arrows: false,
    adaptiveHeight: true,
    accessibility: false,
    dots: false,
    responsive: [
        {
            breakpoint: breakpoints.lg,
            settings: {
                dots: true
            },
        }
    ]
});
$('.product-media .thumbs button').on('click', function (e) {
    e.preventDefault();
    $(".product-media .main").slick('slickGoTo', $(this).data('index'));
    $('.product-media .thumbs button').removeClass('active');
    $(this).addClass('active');
});

$("#related-products-slider").on("init", function (slick) {
    let $slider = $("#related-products-slider");
    var trackHeight = $slider.find(".slick-track").outerHeight();
    $slider.find(".slick-slide").css("height", trackHeight + "px"); // equalize content heights
});

$("#related-products-slider").slick({
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    slidesToShow: 1,
    variableWidth: true,
    mobileFirst: true,
    infinite: false,
    accessibility: false,
    responsive: [
        {
            breakpoint: breakpoints.md,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                variableWidth: false,
            },
        },
        {
            breakpoint: breakpoints.lg,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                variableWidth: false,
            },
        },
        {
            breakpoint: 1365,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                variableWidth: false,
            },
        },
    ],
});
